( function() {
	const body = document.body,
		layoutSwitcher = document.querySelector('.grid-layout-switcher'),
		layoutSwitchers = document.querySelectorAll('.grid-layout-switcher a');

	function switchLayout(e) {
		e.preventDefault();

		// disable click if item is currently selected
		if (e.currentTarget.classList.contains('current-layout-option')) {
			return;
		}

		// if there is a current, remove it, then set the new current
		if (layoutSwitcher.querySelector('.current-layout-option')) {
			layoutSwitcher
				.querySelector('.current-layout-option')
				.classList.remove('current-layout-option');
		}

		// Add current class to last selected
		e.currentTarget.classList.add('current-layout-option');

		// Add layout class to body
		if (body.classList.contains('layout-grid')) {
			body.classList.remove('layout-grid');
		} else {
			body.classList.add('layout-grid');
		}
	}

	if (layoutSwitchers) {
		layoutSwitchers.forEach(switcher => {
			switcher.addEventListener('click', switchLayout);
		}, false);
	}
} )();
